<template>
    <span>
        <!-- <router-link
            v-if="useRouter && encodedId"
            :to="{
                name: 'item',
                params: { id: encodedId }
            }"
        >
            {{ itemName }}
        </router-link> -->
        <a
            v-if="!useRouter && encodedId"
            :href="CI_PATH + encodedId"
            :target="target"
        >
            <span v-if="index != length - 1">{{ letterName }}, </span>
            <span v-else>{{ letterName }}</span>
        </a>
        <span v-else> {{ letterName }} </span>
    </span>
</template>

<script>
export default {
    name: "letterName",
    props: {
        letter: {
            type: Object,
            required: true
        },
        text: {
            type: String,
            default: null
        },
        length: {
            type: Number,
            default: null
        },
        index: {
            type: Number,
            default: null
        },
        // TODO: Once letter route available, use this
        useRouter: {
            type: Boolean,
            default: false
        },
        target: {
            type: String,
            default: "_self"
        }
    },
    data() {
        return {
            CI_PATH: `${process.env.APPS}business/template/view/`
        };
    },
    computed: {
        letterName() {
            return this.text || this.letter.template_name;
        },
        encodedId() {
            return this.letter.encoded_id || this.letter.encodedId;
        }
    }
};
</script>
